import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import moment from 'moment';

import { Grid } from '@mui/material';
import { Container, CustomButtonV2, PageTitle } from '../styles';

import { SearchBar } from '../../components/atoms/searchBars/SearchBar';
import TableWorkflowStatus from '../../components/atoms/tables/TableWorkflowStatus';
import { WorkflowStatusApi } from '../../services/WorkflowStatusApi';
import Router from '../../router';
import { toast } from 'react-toastify';
import { FormatDate } from '../../utils/formatDate';
import { SaveAltRounded, AddCircleOutlineRounded } from '@mui/icons-material';
import { CheckResponse } from '../../utils/checkResponse';
import { useTranslation } from 'react-i18next'
import { ExportExcel } from '../../utils/exportExcel';
import { snakeToCamel } from '../../utils/commonFunctions/convert';
import { ShowDialog } from '../../components/ShowDialog';

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../Context/PermissionsContext'
import NavigateBackButton from '../../components/atoms/NavigateBackButton';

export const WorkflowStatus = (props) => {

  const { i18n, t } = useTranslation();
  const ability = useAbility(AbilityContext);
  const workflowStatusApi = new WorkflowStatusApi();

  // const { colors } = useColors();
  const params = useParams();
  const navigate = useNavigate();
  const [data, setData] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const { id } = useParams();
  const { format } = new FormatDate();
  const { check } = new CheckResponse();

  const [filteredRequest, setFilteredRequest] = React.useState([])
  const [finalDate, setFinalDate] = React.useState(moment(new Date()).format("YYYY-MM-DD"))
  const [initialDate, setInitialDate] = React.useState(moment(finalDate).subtract(1, 'months').format("YYYY-MM-DD"))
  const [datesForm, setDatesForm] = React.useState({
    initialDate: { initialDate },
    finalDate: { finalDate }
  })
	const [dialog, setDialog] = React.useState({
    status: false,
    title: "",
    message: "",
    type: null,
  });


  useEffect(() => {
    async function call() {
			setLoading(true);
      await loadData();
			setLoading(false);
    }
		call()
  }, [i18n.language, params])


    async function loadData(initialDate, finalDate) {
      let resp = [];

      if (ability.can("WorkflowStatusList")) {
        let response = await workflowStatusApi.listAllByWorkflow(id);
        if (response.status === 200) {
          resp = response.data
          resp.map(obj => {
            obj.lastUpdate = obj.updatedAt
            obj.updatedAt = format(obj.updatedAt, true, true);
						obj.typeDescription = t(`workflowManagement.flowState.status.${snakeToCamel(obj.type)}`)
          })
        }
      }

      let standard = [];
      if (ability.can("WorkflowStatusStandardList")) {
        standard = await loadStandardData()
        standard.map((el) => {
          el.isStandard = true
          el.idDetail = id
          el.lastUpdate = el.updatedAt
          el.updatedAt = format(el.updatedAt, true, true);
          el.typeDescription = t(`workflowManagement.flowState.status.${snakeToCamel(el.type)}`)
        })
      }

      let newArray = [...standard, ...resp]

      setData(newArray);
    }

    async function loadStandardData() {
      let response = await workflowStatusApi.listFilterStandard(id);
      if (response.status === 200) {
        return response.data;
      }
    }

    async function handleDatesFilter(e) {
      e.preventDefault()
      setDatesForm({
        ...datesForm,
        initialDate,
        finalDate
      })
      setData(response.data);
    }


  async function handleDatesFilter(e) {
    e.preventDefault()
    setDatesForm({
      ...datesForm,
      initialDate,
      finalDate
    })

    setLoading(true);
    await loadData(initialDate, finalDate);
    setLoading(false);

    e.target.reset()
  }

  async function handleClearDate() {
    setFinalDate(moment(new Date()).format("YYYY-MM-DD"))
    setInitialDate(moment(finalDate).subtract(1, 'months').format("YYYY-MM-DD"))

    setLoading(true);
    await loadData();
    setLoading(false);
  }

	async function handleOpenDialog(row) {
    setDialog({
      status: true,
      title: t('workflowManagement.flowState.messages.confirmDelete.title'),
      message: t('workflowManagement.flowState.messages.confirmDelete.message', {title: row.title}),
      type: "confirmation",
      row: row,
    });
  }

  async function handleDelete(data) {
    let response = await workflowStatusApi.delete(data);
    let result = check(response)

    if (result.status) {
      toast.success(t('workflow.messages.deleteFlow.deleted'));
    } else {
      toast.error(() =>
        <div>{t('workflow.messages.deleteFlow.error')}<br />
          {result.errors}
        </div>
      );
    }
    await loadData();
  }

  async function handleCloseDialog(value) {
    if (value) {
      setDialog({ ...dialog, status: false });
      await handleDelete(dialog.row);
    } else {
      setDialog({ status: false });
    }
  }

  async function handleCreate() {
    navigate(Router.appWorkflowStatusDetail.replace(':id', id), { state: { row: {} } });
  }

  const handleDownloadExcel = () => {

    let data = filteredRequest.map((item) => ({
      [t('workflowManagement.flowState.table.statusCode')]: item.id,
      [t('workflowManagement.flowState.table.title')]: item.title,
      [t('workflowManagement.flowState.table.subtitle')]: item.subtitle,
      [t('workflowManagement.flowState.table.statusType')]: item.typeDescription,
      [t('workflowManagement.flowState.table.color')]: item.color,
      [t('workflowManagement.flowState.table.responsibleRole')]: item.role?.name,
      [t('workflowManagement.flowState.table.lastUpdate')]: format({ date: item.lastUpdate, format:  true }).toString(),
    }))

    ExportExcel({ apiData: data, fileName: t('workflowManagement.flowState.title') });
  }

  return (
    <Container open={props.open} style={{ marginBottom: 0 }}>

      <Grid container 
        spacing={1}
        alignItems="center"
        mb={1}
        columns={{ xs: 12, sm: 12, md: 12, lg: 23, xl: 15 }}>

        <Grid item xs={12} sm={12} md={12} lg={6} xl={4}
          display="flex" flexDirection="row" alignItems="center">
          <NavigateBackButton route={Router.appWorkflowManagement} />
          <PageTitle>{t('workflowManagement.flowState.title')}</PageTitle>
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={8} xl={6}>
          <SearchBar
            rows={data}
            setFilteredRequest={setFilteredRequest}
            filterText={t('common.searchBars.workflowStatus')}
            filterKeys={['statusId', 'title', 'subtitle', 'typeDescription', 'e.role?.name', 'lastUpdate']}
          />
        </Grid>
        
        <Grid item lg={1} xl={2}
          sx={{ display: {xs: 'none', lg: 'block'} }}></Grid>

        <Grid item xs={12} sm={6} md={6} lg={8} xl={3}
          sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          {ability.can("CreateWorkflowStatus") && (
            <CustomButtonV2
              variant="contained"
              btnType="primary"
              startIcon={<AddCircleOutlineRounded />}
              onClick={handleCreate}
            >
              {t('workflowManagement.flowState.table.createFlowState')}
            </CustomButtonV2>
          )}
          <CustomButtonV2
            startIcon={<SaveAltRounded />}
            onClick={handleDownloadExcel}
          >
            {t('common.download')}
          </CustomButtonV2>
        </Grid>
      </Grid>

      <TableWorkflowStatus
        filteredRequest={filteredRequest}
        loading={loading}
        rows={data}
        handleDelete={handleOpenDialog}
      />

			<ShowDialog
        openDialog={dialog.status}
        dialog={dialog}
        handleCloseDialog={handleCloseDialog}
      />

    </Container >
  )
}
